import type { ChangelogEntry } from "../types";

/** Lokasjonsbanken fra Sølvrevs verktøy (VIB-2938). */
export const LOKASJONSBANK_2026_10: ChangelogEntry = {
  id: "2026-10-25-lokasjonsbank",
  date: "2026-10-25",
  title: "Lokasjonsbanken er på plass i Revehiet",
  summary:
    "Stedene fra lokasjonsbanken i Sølvrevs verktøy flyttes inn under Lokasjoner, med bilder, søk og typer. Kart, prosjektkobling og deling med kunde kommer i neste steg.",
  sections: [
    {
      heading: "Lokasjoner",
      minRole: "user",
      items: [
        {
          title: "Lokasjonslista",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Kort eller tabell, med typer som knapper, kommune, innendørs eller utendørs, arkiverte og søk. Lokasjoner finnes også i søket øverst.",
        },
        {
          title: "Ny lokasjon med stedssøk",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Søk opp stedet på adresse eller navn. Posisjon og kommune hentes fra Kartverket for norske adresser, ellers setter du pinnen på kartet. Du får varsel hvis en lokasjon ligger under 150 meter unna fra før.",
        },
        {
          title: "Lokasjonskortet",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Bilder med fullskjerm, dato og posisjon fra kameraet, praktisk info, kontakt, lenker, historikk og lenker til Street View og Google Maps.",
        },
      ],
    },
  ],
};
